import CompaniesShowTemplate from '@/features/agent/companies/templates/CompaniesShowTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/companies/$companiesId/')({
  component: CompaniesShowPage,
});

function CompaniesShowPage() {
  const { companiesId } = Route.useParams();

  return <CompaniesShowTemplate id={companiesId} />;
}
